import { Button } from "@/components/ui/button";
import { Instagram, Mail, MapPin } from "lucide-react";
const CTASection = () => {
  return <footer className="bg-card border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <h3 className="text-2xl font-bold">
                <span className="text-foreground">Karpa</span>
                <span className="bg-gradient-primary bg-clip-text text-transparent ml-1">Investimentos</span>
              </h3>
            </div>
            <p className="text-muted-foreground">
              Copy trade profissional de alta rentabilidade. Replique as operações dos nossos traders especializados em WIN e WDO direto na sua conta. Karpa Investimentos.
            </p>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-lg font-semibold text-foreground mb-4">Redes Sociais</h4>
            <div className="flex space-x-6">
              <a href="https://www.instagram.com/karpainvestimentos/" aria-label="Visite nosso Instagram" className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center hover:bg-primary/20 transition-colors">
                <Instagram className="w-6 h-6 text-primary" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-foreground mb-4">Contato</h4>
            <div className="space-y-3">
              <div className="flex items-center text-muted-foreground">
                <Mail className="w-5 h-5 mr-3 text-primary" />
                <span>administracao@karpainvestimentos.com</span>
              </div>
              <div className="flex items-start text-muted-foreground">
                <MapPin className="w-5 h-5 mr-3 text-primary mt-1" />
                <span>Av. Brig. Faria Lima, 1811 - Jardim Paulistano,<br />São Paulo - SP, 01452-001</span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="py-6 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-muted-foreground text-sm">
              © 2024 Karpa Investimentos. Todos os direitos reservados.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                Termos de Uso
              </a>
              <a href="#" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                Política de Privacidade
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default CTASection;